import {Splide} from '@splidejs/splide';
import {Grid} from '@splidejs/splide-extension-grid';

let logoSlides = document.getElementsByClassName('logo-slider');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < logoSlides.length; i++) {

        let splide = new Splide(logoSlides[i], {
            type: 'slide',
            rewind: true,
            pagination: true,
            arrows: true,
            width: '100%',

            grid: {
                rows: 1,
                cols: 6,
                gap: {
                    row: '3.375rem',
                    col: '2rem',
                },
            },
            breakpoints: {
                1023: {
                    grid: {
                        rows: 1,
                        cols: 4,
                    },
                },
                639: {
                    grid: {
                        rows: 2,
                        cols: 2,
                        gap: {
                            row: '2.5rem',
                            col: '2rem',
                        },
                    },
                },
            },
        });

        splide.mount({Grid});
    }
});
